import React from 'react';
import { Button } from 'reactstrap';

const AddButton = ({ className = '', children, show = true, ...props }) => {
  if (!show) return null;

  return (
    <Button onClick={props.onClick} color="link" className={`add-button ${className}`}>
      {children}
    </Button>
  );
};

export default AddButton;
